import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Icon from "wonderbly-components/lib/Icon";

import "./AccordionItem.scss";

const AccordionLabel = (props) => {
  const { label } = props;

  if (Array.isArray(label) && label.length > 0) {
    return label.map((text) => <div key={`label-${text}`}>{text}</div>);
  }
  return label;
};

const AccordionItem = (props) => {
  const { handleOnClick, label, children } = props;

  return (
    <React.Fragment>
      <div
        className={cx("accordion-item", {
          "accordion-item--active": props.active,
        })}
      >
        <div className="accordion-label padded-wrapper" onClick={handleOnClick}>
          <AccordionLabel label={label} />
          <Icon icon="dropdown" className="accordion-icon" />
        </div>
        <div className="accordion-body">{children}</div>
      </div>
    </React.Fragment>
  );
};

AccordionItem.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  children: PropTypes.element.isRequired,
  handleOnClick: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
};

export default AccordionItem;
